/**
 * 用户 多签章管理
 * 2018.8.4
 */

import ApiPort from "../config/api-port";
import HttpAxios from "./http-axios";
import { dealElement, handleError, handleResponse } from "../lib/common";
import GlobalConfig from '../config/global'

const junziqianApi = GlobalConfig.domain.junziqianApi

export default {

  /**
   * 个人 - 修改签章名称
   * @param signId
   * @param chapterName
   * @returns {Promise<T>}
   */
  updatePreSealName ({ signId, chapterName }) {
    var url = junziqianApi + ApiPort.persionSeal.updateNmae;
    var jsonData = { signId: signId, chapterName: chapterName };

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 全部签章列表 显示章 /fileOper/show?signUrl
   * @returns {Promise<T>}
   */
  getAllPreSeal () {
    var url = junziqianApi + ApiPort.persionSeal.allSeal;

    return HttpAxios.post(url, {}).then(handleResponse).catch(handleError);
  },

  /**
   * 生成签章
   * @param chapterName
   * @param fontType
   * @param color
   * @param path
   * @param signId
   * @returns {Promise<T>}
   */
  createPreSeal ({ chapterName, fontType, color, path, signId }) {
    var url = junziqianApi + ApiPort.persionSeal.create;
    var jsonData = { chapterName: chapterName, fontType: fontType, color: color, path: path, signId: signId };

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 个人 - 分页查询签章
   * @param itemPage
   * @param pageSize
   * @param defauletSign    1只显示默认
   * @returns {Promise<T>}
   */
  getPerSealByPage ({ itemPage, pageSize, defauletSign }) {
    let url = junziqianApi + ApiPort.persionSeal.findByPage;
    var jsonData = { itemPage: itemPage, pageSize: pageSize, defauletSign: defauletSign };

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 个人 - 删除章
   * @param signId
   * @returns {Promise<T>}
   */
  delPreSeal (signId) {
    var url = junziqianApi + ApiPort.persionSeal.del;

    return HttpAxios.post(url, { signId: signId, deleteCtToken: 1 }).then(handleResponse).catch(handleError);
  },

  /**
   * 个人 - 设置默认章
   * @param signId
   * @returns {Promise<T>}
   */
  setPreDefaultSeal (signId) {
    let url = junziqianApi + ApiPort.persionSeal.defaultChapter;

    return HttpAxios.post(url, { signId: signId }).then(handleResponse).catch(handleError);
  },

  /**
   * 企业 - 设置默认章
   * @param signId
   * @returns {Promise<T>}
   */
  setEntDefaultSeal (signId) {
    let url = junziqianApi + ApiPort.enterpriseSeal.defaultChapter;

    return HttpAxios.post(url, { signId: signId }).then(handleResponse).catch(handleError);
  },

  /**
   * 个人 - 预览签章 生成base64图片
   * @param fontType  字体类型 0方正楷体简体 1华文行楷
   * @param color     颜色 0红色 1蓝色
   * @param path      样式 空无背景，0长方形 1正方形
   * @returns {Promise<T>}
   */
  previewSeal ({ fontType, color, path }) {
    let url = junziqianApi + ApiPort.persionSeal.previewSeal;
    let jsonData = { fontType: fontType, color: color, path: path };

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 给子系统分配签章
   * @param signGives string  系统[{"sourceTagId：xx ,sourceTag:xx"}] 若取消则传[]
   * @param signId 章id
   * @returns {Promise<T>}
   */
  giveUpdate ({ signGives, signId }) {
    let url = junziqianApi + ApiPort.entSignController.giveUpdate
    let jsonData = { signGives: signGives, signId: signId }

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 查询签章使用的子系统
   * @param signId  章id
   * @returns {Promise<T>}
   */
  giveList (signId) {
    let url = junziqianApi + ApiPort.entSignController.giveList
    let jsonData = { signId: signId }
    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 删除签章
   * @param signId  章id
   * @returns {Promise<T>}
   */
  del (signId) {
    let url = junziqianApi + ApiPort.entSignController.del
    let jsonData = { signId: signId }

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
     * 【1714】新版保存或更新签章(个人)
     * @param image  章image文件（预览接口后的文件流）
     * @param signName 章名称
     * @param color 章颜色 （1红2蓝3黑）
     * @param range 颜色范围（背景透明度 1 - 255）
     * @param width  章宽度
     * @param height  章高度
     * @param signId  章id
     * @returns {Promise<T>}
     */
  perSignFileUpdate (FD) {
    let url = junziqianApi + ApiPort.entSignController.perSignFileUpdate
    return HttpAxios.postForm(url, FD)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
     * 【1714】新版保存或更新签章
     * @param image  章image文件（预览接口后的文件流）
     * @param signName  章名称
     * @param color 章颜色
     * @param range 颜色范围（背景透明度 1 - 255）
     * @param width  章宽度
     * @param height  章高度
     * @param signId  章id
     * @returns {Promise<T>}
     */
  fileSealUpadte (FD) {
    let url = junziqianApi + ApiPort.entSignController.fileUpdate
    return HttpAxios.postForm(url, FD)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
 * 【1714】预览签章效果
 * @param image   章image base64格式
 * @param range  色彩范围（背景透明度）
 * @param color  章颜色
 * @returns {Promise<T>}
 */
  uploadPreview (params) {
    let url = junziqianApi + ApiPort.entSignController.uploadPreview
    let jsonData = { ...params }
    jsonData = dealElement(jsonData)
    return HttpAxios.post(url, jsonData, { responseType: 'arraybuffer' }).then(response => {//返回json
      return Promise.resolve(response.data);
    }).catch(err => { // 请求失败
      Vue.prototype.$message.error('请求超时');
      return Promise.reject(err);
    });
  },
  /**
   * 保存或更新签章--先要调用上传临时文件的方法，然后获取上传文件返回的参数，传入该方法
   * @param targetId  章targetId
   * @param targetFix  章后缀.png
   * @param signName  章名称
   * @param productionType    章制作类型(1为在线制作 其他为自主制作)
   * @param titleText  抬头
   * @param mainText  主文字
   * @param signCode  印章编码
   * @param signType  印章图形类型(0圆形章, 1椭圆形章)
   * @param signId  章id
   * @param color 章颜色
   * @returns {Promise<T>}
   */
  update (data) {
    let url = junziqianApi + ApiPort.entSignController.update
    let jsonData = { ...data }
    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
   * 创建签章签生成签章效果
   * @param titleText  抬头
   * @param mainText  主文字
   * @param signName  章名称
   * @param signCode 印章编码
   * @param signType 印章类型(0圆形章, 1椭圆形章)
   * @returns {Promise<T>}
   */
  previewSign (params) {
    let url = junziqianApi + ApiPort.entSignController.previewSign
    let jsonData = { ...params }
    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
   * 禁止成员使用签章
   * @param signId
   */
  disableMemberUse (signId) {
    let url = junziqianApi + ApiPort.entSignController.disableMemberUse
    let jsonData = { signId }
    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },
  /**
   * 允许成员使用签章
   * @param {Number} signId
   */
  allowMemberUse (signIds) {
    let url = junziqianApi + ApiPort.entSignController.allowMemberUse
    let jsonData = { signIds }
    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },


  /**
   * 分页获取签章列表
   * @param itemPage
   * @param pageSize
   * @returns {Promise<T>}
   */
  findByPage (itemPage, pageSize) {
    let url = junziqianApi + ApiPort.entSignController.findByPage
    let jsonData = { itemPage: itemPage, pageSize: pageSize }
    jsonData = dealElement(jsonData)

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  },

  /**
   * 获取全部签章列表
   * @returns {Promise<T>}
   * @param filterCorpSeal 过滤条件 1 未使用
   */
  getAll (filterCorpSeal) {
    let url = junziqianApi + ApiPort.entSignController.getAll, jsonData = filterCorpSeal ? { filterCorpSeal } : {}

    return HttpAxios.post(url, jsonData)
      .then(handleResponse)
      .catch(handleError)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/entSignController.js